export default __webpack_public_path__ + "static/media/hht1_ep11_timeline_q02_b.6248edc1.png";